import React from "react";
import "./CareProcess.css";
import { useTranslation } from "react-i18next";

import {
  FaPhoneAlt,
  FaComments,
  FaClipboardCheck,
  FaUserNurse,
  FaHeartbeat,
} from "react-icons/fa";

const CareProcess = () => {
  const { t } = useTranslation();

  // Array moved inside to ensure t() refreshes on language change
  const steps = [
    {
      number: "01",
      icon: <FaPhoneAlt />,
      title: "care_step1_title",
      desc: "care_step1_desc",
      color: "step-yellow",
    },
    {
      number: "02",
      icon: <FaComments />,
      title: "care_step2_title",
      desc: "care_step2_desc",
      color: "step-orange",
    },
    {
      number: "03",
      icon: <FaClipboardCheck />,
      title: "care_step3_title",
      desc: "care_step3_desc",
      color: "step-blue",
    },
    {
      number: "04",
      icon: <FaUserNurse />,
      title: "care_step4_title",
      desc: "care_step4_desc",
      color: "step-teal",
    },
    {
      number: "05",
      icon: <FaHeartbeat />,
      title: "care_step5_title",
      desc: "care_step5_desc",
      color: "step-green",
    },
  ];

  return (
    <section className="care-section">
      <h2>{t("care_process_heading")}</h2>

      <div className="care-wrapper">
        {steps.map((step, index) => (
          <div key={index} className="care-card-wrapper">
            <div className={`care-card ${step.color}`}>
              <div className="care-ribbon">
                <span>{step.number}</span>
              </div>

              <div className="care-icon">{step.icon}</div>

              <h4>{t(step.title)}</h4>
              <p>{t(step.desc)}</p>
            </div>

            {index !== steps.length - 1 && (
              <div className="care-arrow">➜</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default CareProcess;